<template>
    <div
        :class="`story-maker-post-creator ${cursorName}`"
        :style="{ fontSize: fontSize + 'px' }"
        ref="story-maker"
    >
        <div class="lock" v-if="previewEnabled" :class="{ 'hover-sticker': hoveredStickerId }" @click="handlePreviewClick" @mousemove="handlePreviewMouseMove" @mouseleave="handlePreviewMouseLeave"></div>
        <stickerFocus
            v-if="previewEnabled && focusedSticker"
            :sticker="focusedSticker"
            :wrapper="stickerWrapperComponent"
            :files="files"
            :pageSelected="pageSelected"
            :backgroundFileId="backgroundFileId"
        />
        <div
            class="overflow"
            :class="{axeX: showAxe.x, axeY: showAxe.y}"
            :style="{'--z-index-axe': showAxe.index, backgroundColor: story.background.color}"
        >

            <div class="page-name" v-if="previewEnabled && pageSelected">
                <vs-avatar
                    class="page-img"
                    color="transparent"
                    size="28px"
                    :src="pageSelected.avatar"
                />
                <p>{{ pageSelected.name }}</p>
            </div>

            <template v-if="showAlertDelete">
                <alert v-if="Object.keys(formData.storification).length > 1"
                    title="Supprimer la story ?" subTitle="Si vous supprimer cette story, vous perdrez toutes les modification que vous avez apportées"
                    :choices="[
                        {content:'Supprimer', warning: true, cb: handleDeleteStory},
                        {content:'Continuer les modifications',  cb: ()=>showAlertDelete=false}
                    ]"
                />
                <alert v-else
                    title="Réinitialiser la story ?" subTitle="Si vous réinitialiser cette story, vous perdrez toutes les modification que vous avez apportées"
                    :choices="[
                        {content:'Réinitialiser', warning: true, cb: handleResetStory},
                        {content:'Continuer les modifications',  cb: ()=>showAlertDelete=false}
                    ]"
                />
            </template>

            <template v-if="!overlayMode && !previewEnabled">
                <div class="btns-action" data-html2canvas-ignore="true">
                    <div class="btn sound" v-if="musicSticker || backgroundIsVideo" :class="{'muted': mutedSound}" @click="toggleMuteSound"></div>

                    <div class="btn resize" v-if="backgroundFileId && files[backgroundFileId]" :class="{'btn-primary': editMode}" @click="editMode = !editMode">
                        <i class="fa-solid fa-crop-simple"></i>
                    </div>
                    <div class="btn text" @click="addText">
                        <img :src="require('@/assets/img/instagram/icon_story_text.png')">
                    </div>
                    <div class="btn stickers" @click="setOverlay('stickers')">
                        <img :src="require('@/assets/img/instagram/icon_story_sticker.png')">
                    </div>

                    <Tooltip
                        v-if="pagesSelectedIncludeConciergerie && (musicSticker || !backgroundIsVideo)"
                        @click="() => { musicSticker ? updateSticker(musicSticker.id, {isEditing : true}) : setOverlay('stickers-musicMenu')}"
                        :active="!!musicSticker"
                        :text="!!musicSticker && `${musicSticker.data.music.track.display_artist} - ${musicSticker.data.music.track.title}`"
                        position="bottom"
                        classCustom="btn music"
                    >
                        <img v-if="musicSticker" class="thumbnail-music" :src="musicSticker.data.music.track.cover_artwork_thumbnail_uri">
                        <img v-else :src="require('@/assets/img/instagram/icon_story_music.png')">
                    </Tooltip>
                </div>

                <div class="btn delete-story" @click="handleDeleteStory" data-html2canvas-ignore="true">
                    <img :src="require('@/assets/img/instagram/instagram_x_outline_44.png')">
                </div>

                <div class="btn-background-resize" v-if="editMode && backgroundFileId && files[backgroundFileId]">
                    <template v-if="files[backgroundFileId].info.aspectRatio > 0.5625">
                        <i class="fa-sharp fa-regular fa-arrow-up-right-and-arrow-down-left-from-center" style="transform: rotate(45deg);" @click="setSizeBackground('containX')"></i>
                        <i class="fa-sharp fa-regular fa-arrow-up-right-and-arrow-down-left-from-center" @click="setSizeBackground('containY')"></i>
                    </template>
                    <template v-else>
                        <i class="fa-sharp fa-regular fa-arrow-up-right-and-arrow-down-left-from-center" style="transform: rotate(135deg);" @click="setSizeBackground('containY')"></i>
                        <i class="fa-sharp fa-regular fa-arrow-up-right-and-arrow-down-left-from-center" @click="setSizeBackground('containX')"></i>
                    </template>
                </div>
            </template>

            <div v-else-if="!previewEnabled && overlayMode && overlayMode.slice(0,8) == 'stickers'" class="btns-action">
                <div class="btn cancel" @click="closeOverlay">
                    <img :src="require('@/assets/img/instagram/instagram_x_outline_44.png')">
                </div>
            </div>

            <div class="trash-stiker" v-if="onStickerDrag" @mouseover="trashIsHover = true" @mouseleave="trashIsHover = false" :class="{active : trashIsHover}">
                <div class="icon"></div>
            </div>

            <div class="container-bg-story" :class="{edit: editMode}">
                <draggable
                    :position="story.background.position"
                    :transform="story.background.transform"
                    :classCustom="story.background.size"
                    :disableTransform="!editMode"
                    :disableMove="!editMode"
                    disableIncreaseZIndex
                    disableDelete
                    @saveFormData="() => $emit('saveFormData')"
                >
                    <div class="bg-story selectDisable" :class="story.background.size">
                        <template v-if="backgroundFileId && files[backgroundFileId]">
                            <img v-if="files[backgroundFileId].info.type.startsWith('image/')" class="selectDisable" :src="files[backgroundFileId].url" draggable="false">
                            <video
                                v-else-if="files[backgroundFileId].info.type.startsWith('video/')"
                                ref="video"
                                :src="files[backgroundFileId].url"
                                :type="files[backgroundFileId].info.type"
                                class="source"
                                preload="metadata"
                                muted
                                autoplay
                                loop
                                playsinline
                                @loadedmetadata="syncVideoMute"
                                @timeupdate="videoCheckLoop"
                            ></video>
                        </template>
                    </div>
                </draggable>
            </div>

            <template v-if="!editMode" v-for="sticker in draggableStickers">
                <draggable
                    :key="sticker.id"
                    :position="sticker.position"
                    :transform="sticker.transform"
                    :disableTransform="sticker.disableTransform"
                    :disableMove="sticker.disableMove"
                    :disableDelete="sticker.disableDelete"
                    :disableIncreaseZIndex="sticker.disableIncreaseZIndex"
                    :zIndex="sticker.zIndex"
                    :trashIsHover="trashIsHover"
                    :classCustom="`story-maker-draggable-sticker ${sticker.type} id-${sticker.id}`"
                    @setDragState="(state)=>{onStickerDrag=state; trashIsHover=false}"
                    @setStoryMakerCursor="setCursor"
                    @increaseZIndex="()=>increaseZIndexSticker(sticker.id)"
                    @deleteSticker="()=>deleteSticker(sticker.id)"
                    @saveFormData="() => $emit('saveFormData')"
                    @setShowAxe="setShowAxe"
                >
                    <template v-slot="{ setCover, setCbClick, isPreventCover, isCover }">
                        <stickerWrapperFacebook
                            :sticker="sticker"
                            :isPreventCover="isPreventCover"
                            :isCover="isCover"
                            :setCover="setCover"
                            :setCbClick="setCbClick"
                            :files="files"
                            :backgroundFileId="backgroundFileId"
                            :pageSelected="pageSelected"
                            :previewEnabled="previewEnabled"
                            @updateSticker="updateSticker"
                            @deleteSticker="deleteSticker"
                        />
                    </template>
                </draggable>
            </template>

            <div class="music-sticker-editor" v-if="!editMode && !previewEnabled && musicSticker && musicSticker.isEditing">
                <stickerWrapperFacebook
                    :sticker="musicSticker"
                    :pageSelected="pageSelected"
                    :previewEnabled="previewEnabled"
                    @updateSticker="updateSticker"
                    @deleteSticker="deleteSticker"
                />
            </div>

            <div class="link-sticker-fixed" v-if="!editMode && linkSticker">
                <stickerWrapperFacebook
                    :sticker="linkSticker"
                    :pageSelected="pageSelected"
                    :previewEnabled="previewEnabled"
                    @updateSticker="updateSticker"
                    @deleteSticker="deleteSticker"
                />
            </div>

            <StickerMenuFacebook
                v-if="!previewEnabled && overlayMode && overlayMode.split('-')[0] == 'stickers'"
                :menuNameDefault="overlayMode.split('-')[1]"
                :overlayData="overlayData"
                :stickers="Object.values(story.stickers)"
                :pageSelected="pageSelected"
                :dataStoryMakerDefault="dataStoryMakerDefault"
                :pagesSelectedIncludeConciergerie="pagesSelectedIncludeConciergerie"
                :backgroundIsVideo="backgroundIsVideo"
                @addSticker="addSticker"
                @updateSticker="updateSticker"
                @deleteSticker="deleteSticker"
                @close="closeOverlay"
            />

        </div>

        <audio
            v-if="musicSticker"
            ref="audio"
            :src="musicSticker.data.music.track.fast_start_progressive_download_url"
            autoplay
            loop
            @loadedmetadata="setStartMusic"
            @timeupdate="checkTimeMusic"
            @canplaythrough="(e) => e.target.volume = mutedSound ? '0' : '0.5'"
        ></audio>

        <div
            v-if="previewEnabled && (musicSticker || backgroundIsVideo)"
            :key="mutedSound ? 'no-sound' : 'sound'"
            :class="mutedSound ? 'no-sound' : 'sound'"
            @click="toggleMuteSound"
        ></div>
    </div>
</template>

<script>
import { EventBus } from '@/event-bus';
import draggable from './storyMaker/draggable.vue';
import stickerWrapperFacebook from './storyMaker/stiker/stickerWrapperFacebook.vue';
import StickerMenuFacebook from './storyMaker/stickerMenu/mainFacebook.vue';
import { stickerDataDefault } from './storyMaker/stickerMenu/main.vue';
import alert from './storyMaker/alert.vue';
import { findStickerAtPoint, getStickerTargetUrl, FOCUSABLE_STICKER_TYPES } from './storyMaker/stickerTargetUrl.js';
import stickerFocus from './storyMaker/stickerFocus.vue';
import previewStickerTooltip from './storyMaker/previewStickerTooltip.js';
import Tooltip from '@/components/dash/tooltip/tooltipInit.vue';
import minxinPost from '@/components/mixins/Posts.vue';
import { formDataDefault } from '@/components/dash/postCreator/constante.js';
import { allFacebookNative } from '@/components/dash/postCreator/utils.js';

export default {
    mixins: [minxinPost, previewStickerTooltip],

    components: {
        draggable,
        stickerWrapperFacebook,
        StickerMenuFacebook,
        alert,
        Tooltip,
        stickerFocus,
    },

    props: {
        formData: Object,
        files: Object,
        pageSelected: Object,
        idStorySelected: {
            type: String,
            default: '0'
        },
        deleteStory: Function,
        previewEnabled: {
            type: Boolean,
            default: false
        },
    },

    data() {
        return {
            fontSize: 0,
            editMode: false,
            showAlertDelete: false,
            resizeObserver: null,
            zIndex: 10,
            overlayMode: false,
            overlayData: null,
            onStickerDrag: false,
            trashIsHover: false,
            mutedSound: true,
            focusedSticker: null,
            cursorName: '',
            showAxe: {
                x: false,
                y: false,
                index: -1,
            },
        }
    },

    watch: {
        musicSticker: {
            immediate: true,
            handler() {
                this.$nextTick(this.syncVideoMute)
            }
        },

        idStorySelected: {
            immediate: true,
            handler() {
                this.focusedSticker = null
                if (!this.story) return
                if (!this.story.stickers) this.$set(this.story, 'stickers', {})
                const max = Math.max(10, ...Object.values(this.story.stickers).map(s => s.zIndex || 0))
                if (max >= this.zIndex) this.zIndex = max + 1
            }
        },
    },

    mounted() {
        this.resizeObserver = new ResizeObserver(() => {
            this.updateFontSize();
        });
        this.resizeObserver.observe(this.$refs['story-maker']);
        this.updateFontSize();

        EventBus.$on('storyMaker-setOverlay', this.setOverlay);

        if (!this.previewEnabled) this.getDataStoryMakerDefaultFacebook();
    },

    beforeDestroy() {
        if (this.resizeObserver) {
            this.resizeObserver.disconnect();
        }
        EventBus.$off('storyMaker-setOverlay', this.setOverlay);
    },

    methods: {
        handleDeleteStory() {
            if (!this.showAlertDelete) {
                this.showAlertDelete = true
                return
            }
            if (this.deleteStory) this.deleteStory()
            this.showAlertDelete = false
        },
        handleResetStory() {
            this.$set(this.formData.storification, this.idStorySelected, JSON.parse(JSON.stringify(formDataDefault.storification['0'])))
            this.showAlertDelete = false
            this.$emit('saveFormData')
        },
        updateFontSize() {
            this.fontSize = this.$refs['story-maker'].offsetWidth;
        },

        setSizeBackground(size) {
            this.$set(this.story.background, 'size', size)
            this.$set(this.story.background, 'position', {"x":50,"y":50})
            this.$set(this.story.background, 'transform', {"rotate":0,"scale":1})
            this.$emit('saveFormData')
        },

        addText() {
            this.addSticker({...JSON.parse(JSON.stringify(stickerDataDefault['text']))})
        },

        addSticker(sticker) {
            if (!sticker.id) sticker.id = Date.now()
            if (!sticker.zIndex) sticker.zIndex = ++this.zIndex

            const typeStickersUnique = { link: 'delete', music: 'delete' }
            if (typeStickersUnique[sticker.type]) {
                const existing = Object.values(this.story.stickers).find(s => s.type === sticker.type)
                if (existing) {
                    if (typeStickersUnique[sticker.type] === 'delete') {
                        this.$delete(this.story.stickers, existing.id)
                    } else {
                        sticker = { ...existing, isEditing: true }
                    }
                }
            }

            this.$set(this.story.stickers, sticker.id, sticker)
            this.$emit('saveFormData')
        },

        updateSticker(id, payload) {
            this.$set(this.story.stickers, id, {
                ...this.story.stickers[id],
                ...payload
            })
            this.$emit('saveFormData')
        },

        deleteSticker(id) {
            this.$delete(this.story.stickers, id)
            this.$emit('saveFormData')
        },

        increaseZIndexSticker(id) {
            const sticker = this.story.stickers[id]
            if (sticker.zIndex === this.zIndex) return
            this.$set(this.story.stickers, id, {
                ...sticker,
                zIndex: ++this.zIndex
            })
            this.$emit('saveFormData')
        },

        setOverlay(name, data) {
            this.overlayMode = name
            this.overlayData = data || null
        },

        setCursor(cursorName) {
            this.cursorName = cursorName
        },

        setShowAxe(axe, bool) {
            this.$set(this.showAxe, axe, bool)
        },

        closeOverlay() {
            this.overlayMode = false
            this.overlayData = null
        },

        syncVideoMute() {
            if (this.$refs.video) this.$refs.video.muted = this.mutedSound || !!this.musicSticker
        },

        toggleMuteSound() {
            this.setMuteSound(!this.mutedSound)
        },

        handlePreviewClick(e) {
            this.hidePreviewTooltip()
            if (this.focusedSticker) {
                this.focusedSticker = null
                return
            }
            // Le calque .lock masque les stickers : on cherche le sticker sous le curseur
            const hit = findStickerAtPoint(this.$el, this.previewStickers, e.clientX, e.clientY)
            if (hit) {
                const url = getStickerTargetUrl(hit.sticker, 'facebook', hit.element)
                if (url) {
                    window.open(url, '_blank', 'noopener')
                    return
                }
                if (FOCUSABLE_STICKER_TYPES.includes(hit.sticker.type)) {
                    this.focusedSticker = hit.sticker
                    return
                }
            }
            if (this.musicSticker || this.backgroundIsVideo) this.toggleMuteSound()
        },

        setMuteSound(bool) {
            this.mutedSound = bool
            const audio = this.$refs.audio
            if (audio) audio.volume = this.mutedSound ? 0 : 0.5
            this.syncVideoMute()
        },

        videoCheckLoop(e) {
            if (e.target.currentTime <= 0.2) {
                this.restartMusic()
            }

            if (e.target.currentTime >= 60) {
                e.target.currentTime = 0
            }
        },

        setStartMusic(e) {
            const audio = e ? e.target : this.$refs.audio
            if (audio && this.musicSticker) {
                const currentTimeVideo = this.$refs.video ? this.$refs.video.currentTime : 0
                audio.currentTime = (this.musicSticker.data.start || 0) / 1000 + currentTimeVideo
            }
        },

        restartMusic(e) {
            const audio = e ? e.target : this.$refs.audio
            if (audio && this.musicSticker) {
                audio.currentTime = (this.musicSticker.data.start || 0) / 1000
            }
        },

        checkTimeMusic(e) {
            if (e.target && this.musicSticker) {
                if (e.target.currentTime < (this.musicSticker.data.start || 0) / 1000) {
                    this.restartMusic()
                }

                if (this.musicSticker.data.rangeDuration) {
                    const endTime = ((this.musicSticker.data.start || 0) + this.musicSticker.data.rangeDuration) / 1000
                    if (!this.$refs.video && e.target.currentTime >= endTime) {
                        this.restartMusic()
                    }
                }
            }
        },

        async getDataStoryMakerDefaultFacebook() {
            if (this.dataStoryMakerDefault.musicsFacebook && this.dataStoryMakerDefault.musicsFacebook.length) return

            const page = this.pagesSelected.find(p => p && p.network == 'facebook' && p.story_config && p.story_config.created)
            if (!page) return

            try {
                const res = await this.getMusicFacebook(page.id)
                const feeds = res && res.body && res.body.feeds
                if (Array.isArray(feeds) && feeds.length) {
                    this.$store.commit('postCreator/updateDataStoryMakerDefault', { musicsFacebook: feeds })
                }
            } catch (error) {
                console.log('getDataStoryMakerDefaultFacebook error', error)
            }
        },
    },

    computed: {
        story() {
            return this.formData.storification[this.idStorySelected] || this.formData.storification['0']
        },
        stickerWrapperComponent() {
            return stickerWrapperFacebook
        },
        previewStickers() {
            return Object.values(this.story.stickers)
        },
        previewNetwork() {
            return 'facebook'
        },
        backgroundFileId() {
            const fileRef = this.story.background.file
            return fileRef ? fileRef.id : null
        },

        draggableStickers() {
            return Object.values(this.story.stickers).filter(sticker => sticker.type !== 'link' && sticker.type !== 'music')
        },

        linkSticker() {
            return Object.values(this.story.stickers).find(sticker => sticker.type === 'link') || null
        },

        musicSticker() {
            return Object.values(this.story.stickers).find(sticker => sticker.type === 'music') || null
        },

        backgroundIsVideo() {
            return !!(this.backgroundFileId && this.files[this.backgroundFileId] && this.files[this.backgroundFileId].info.type.startsWith('video/'))
        },

        dataStoryMakerDefault() {
            return this.$store.getters['postCreator/dataStoryMakerDefault']
        },

        allPages() {
            return this.$store.getters['selectPage/selectPageAllPages']
        },

        pagesSelected() {
            return this.$store.getters['selectPage/selectPagePageSelected'].map(id => this.allPages[id])
        },

        pagesSelectedIncludeConciergerie() {
            return allFacebookNative(this.pagesSelected)
        },
    },
}
</script>
